import angular from 'angular';

export class SocialDeprecationNotice {
  public isAppReviewClient;

  constructor(private SessionVarsService) {
    this.isAppReviewClient = this.SessionVarsService.isFacebookReview();
  }
}

angular.module('curalate').component('socialDeprecationNotice', {
  controller: [
    'SessionVarsService',
    SocialDeprecationNotice,
  ],
  template: `<cu-alert type='warning' class="cu-d-block cu-mt-4" ng-if="!$ctrl.isAppReviewClient">
        <ng-transclude></ng-transclude>
    </cu-alert>`,
  transclude: true,
});
